import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle, ShieldCheck, Zap, Gift } from 'lucide-react';
import { WistiaVideo } from './WistiaVideo';
export function Hero() {
  return <section className="relative overflow-hidden pt-8 pb-12 lg:pt-16 lg:pb-16 px-4" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        {/* Title */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-64">
          <h1 className="text-4xl lg:text-6xl font-bold text-[#2B0A3D] leading-tight mb-6" data-id="element-65">
            No estás bloqueada. <br data-id="element-66" />
            <span className="text-[#D4AF37] italic" data-id="element-67">Estás programada.</span>
          </h1>

          <p className="text-lg lg:text-xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-68">
            Esta guía te da un sistema simple de 21 días para reprogramar
            creencias, visualizar con claridad y tomar acción… sin forzarte y
            sin improvisar.
          </p>

          {/* Wistia Video */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="max-w-3xl mx-auto mb-8 rounded-2xl overflow-hidden shadow-2xl" data-id="element-69">
            <WistiaVideo data-id="element-70" />
          </motion.div>
        </motion.div>

        {/* Bullet List */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="text-center mb-6" data-id="element-71">
          <ul className="space-y-4 mb-6 max-w-2xl mx-auto text-left" data-id="element-72">
            {['Plan paso a paso (no rituales sueltos)', 'Rutina AM/PM corta (10–15 min)', 'Acción diaria para materializar'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4 + index * 0.05,
            duration: 0.3
          }} className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-73">
                <CheckCircle className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-74" />
                {item}
              </motion.li>)}
          </ul>

          {/* Special Offer Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="inline-flex items-center gap-2 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] px-6 py-3 rounded-full shadow-lg mb-4" data-id="element-75">
            <Gift className="w-5 h-5 text-[#2B0A3D]" data-id="element-76" />
            <span className="text-[#2B0A3D] font-bold text-lg" data-id="element-77">
              Pagas 1 llevas 6 Ebooks
            </span>
          </motion.div>
        </motion.div>

        {/* Book Image - Below "Pagas 1 llevas 6 Ebooks" */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.7
      }} className="flex justify-center mb-8" data-id="element-78">
          <div className="relative w-64 h-96 sm:w-80 sm:h-[480px]" data-id="element-79">
            <img src="https://i.ibb.co/N2BV1x2k/Portada-Libro.png" alt="El Secreto de la Abundancia - Portada del libro" className="w-full h-full object-contain drop-shadow-2xl" loading="eager" fetchPriority="high" width="320" height="480" data-id="element-80" />
          </div>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.8
      }} className="text-center" data-id="element-81">
          <div className="flex justify-center mb-6" data-id="element-82">
            <Button scrollTo="incluye" variant="outline" size="lg" data-id="element-83">
              Quiero acceso
            </Button>
          </div>

          <div className="flex flex-wrap gap-4 text-xs text-gray-500 items-center justify-center" data-id="element-84">
            <span className="flex items-center gap-1" data-id="element-85">
              <ShieldCheck className="w-3 h-3" data-id="element-86" /> Pago seguro
            </span>
            <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-87"></span>
            <span className="flex items-center gap-1" data-id="element-88">
              <Zap className="w-3 h-3" data-id="element-89" /> Acceso inmediato
            </span>
            <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-90"></span>
            <span data-id="element-91">Resultados varían según tu constancia</span>
          </div>
        </motion.div>
      </div>
    </section>;
}